export default __webpack_public_path__ + "static/media/i30.6315b078.svg";